import { InjectionToken } from '@angular/core';
import { PlAPIConfig } from './models';

export const PL_API_CONFIG = new InjectionToken<PlAPIConfig>('APIConfig');
